import * as types from './constants';

// Get Network Orders
export const getNetworkOrdersRequest = data => (
  { type: types.GET_NETWORK_ORDERS_REQUEST, payload: data }
);

export const getNetworkOrdersDone = data => (
  { type: types.GET_NETWORK_ORDERS_DONE, payload: data }
);

export const getNetworkOrdersFailed = errors => (
  { type: types.GET_NETWORK_ORDERS_FAILED, payload: errors }
);

// Operations
// One chip is active at a time but it may belong to either axis, so both are set together -
// picking an invoice chip has to clear the order one and vice versa.
export const setNetworkOrdersStatusFilter = ({ status, invoiceStatus }) => (
  { type: types.SET_NETWORK_ORDERS_STATUS_FILTER, payload: { status, invoiceStatus } }
);

export const setNetworkOrdersSearchFilter = searchQ => (
  { type: types.SET_NETWORK_ORDERS_SEARCH_FILTER, payload: searchQ }
);

export const setNetworkOrdersDateRangeFilter = dateRange => (
  { type: types.SET_NETWORK_ORDERS_DATE_RANGE_FILTER, payload: dateRange }
);

export const networkOrdersSetPage = data => (
  { type: types.NETWORK_ORDERS_SET_PAGE, payload: data }
);
